import { Box } from "@mui/material";
import StatisticsHeader from "./StatisticsHeader";
import StatisticsTabs from "./StatisticsTabs";

const StatisticsPage = (): JSX.Element => {
  return (
    <Box>
      <StatisticsHeader />
      <StatisticsTabs />
    </Box>
  );
};

export default StatisticsPage;
